import RobotList from './RobotList';
import RobotGroup from './RobotGroup';
import EnterpriseSetting from './EnterpriseSetting';

export default {
  RobotList,
  RobotGroup,
  EnterpriseSetting,
};



// WEBPACK FOOTER //
// ./src/manage-modules/RobotManage/index.js